export enum DomensEnum {
    Stage = 'https://stage.alfamedonline.ru',
    Demo = 'https://alfamed.demo.mobecan.com',
    Local = 'http://localhost',
}
const domensDev = [DomensEnum.Stage, DomensEnum.Demo, DomensEnum.Local];

export const getIsDemo = () => {
    return Boolean(
        domensDev.find(domenName => window.location.origin.indexOf(domenName) !== -1)
    );
}

export const getIsProd = () => {
    return Boolean(
        domensDev.find(domenName => window.location.origin.indexOf(domenName) === -1)
    );
}
